// extracted by mini-css-extract-plugin
module.exports = {"aboutOwnerMini":"jgp-3X120","image":"jgp-MvDM6","title":"jgp-12W01","description":"jgp-Z0cSC"};